import React from "react";
import {
  Box,
  Typography,
  Grid,
  Paper,
  Stack,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import ApplicationStepper from "./ApplicationStepper";
import SalaryLoanSection from "../LoanCarousel/LoanSectionCarousel";
import styles from "../../personal-loan-landing.module.css";
import { CardComponent } from "@/components";
import { IMAGES, WEB_COLORS } from "@/lib/constants";
import Image from "next/image";

const features = [
  {
    src: IMAGES.quicktimeDark,
    title: "Instant Loan Approval",
    description:
      "Get approval for your loan in 10 minutes when you apply online on the Hero FinCorp website or loan application.",
  },
  {
    src: IMAGES.lendMoneyDark,
    title: "Quick Loan Disbursal",
    description:
      "Receive loan disbursal directly in your bank account, ensuring timely money when you need it.",
  },
  {
    src: IMAGES.documentDark,
    title: "Paperless Application process",
    description:
      "When you apply online, you don't have to submit any physical documents. This saves your time and effort.",
  },
  {
    src: IMAGES.documentDark,
    title: "No Collateral Requirement",
    description:
      "You can avail a Personal Loan without any collateral, guarantor or security.",
  },
  {
    src: IMAGES.documentDark,
    title: "Flexible Loan Amounts",
    description:
      "Avail loans between Rs 50,000 to 5 Lakh for multiple purposes like medical treatment, home improvement, or a holiday of your dreams.",
  },
  {
    src: IMAGES.documentDark,
    title: "Tailored Repayment Tenures",
    description:
      "Select a repayment term from 12 to 36 months, according to your budget and financial needs.",
  },
];

const FeaturesUI = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <>
      <Box sx={{ p: { xs: 1, md: 0 }, borderRadius: { xs: "20px", md: 0 } }}>
        <Box
          sx={{
            px: {
              xs: 2,
              md: 5,
            },
            pb: {
              xs: 2,
              md: 5,
            },
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Box
            width={10}
            height={200}
            sx={{
              background: "linear-gradient(to bottom, #00F200, #ffffff)", // Gradient from top to bottom
              borderRadius: "10px 10px 0 0", // Rounded top corners
              display: {
                xs: "none",
                md: "flex",
              },
            }}
          ></Box>
          {!isMobile && (
            <Box width={800} px={4}>
              <Typography
                variant="h4"
                fontWeight="700"
                gutterBottom
                color={WEB_COLORS.darkTeal}
                sx={{
                  fontSize: {
                    xs: 20,
                    md: 40,
                  },
                }}
              >
                What Makes Hero FinCorp Personal Loan a Smart Choice?
              </Typography>
              <Typography
                color={"#3F3F3FCC"}
                fontWeight={400}
                sx={{
                  fontSize: {
                    xs: 12,
                    md: 18,
                  },
                }}
              >
                Experience the numerous advantages and features of a Personal
                Loan. From fulfilling your dreams to tackling unexpected
                expenses, a Personal Loan provides financial flexibility and
                convenience.
              </Typography>
            </Box>
          )}
        </Box>
        <Grid
          container
          className={styles["features"]}
          sx={{
            px: { xs: 1, md: 6 },
            py: { xs: 2, md: 6 },
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {isMobile && (
            <Box width={800} px={2}>
              <Typography
                color={"#fff"}
                sx={{
                  fontSize: "16px",
                  fontWeight: 400,
                }}
              >
                What Makes Hero FinCorp Personal Loan a Smart Choice?
              </Typography>
              <Typography
                color={"#fff"}
                fontWeight={400}
                sx={{
                  fontSize: 12,
                }}
              >
                Experience the numerous advantages and features of a Personal
                Loan. From fulfilling your dreams to tackling unexpected
                expenses, a Personal Loan provides financial flexibility and
                convenience.
              </Typography>
            </Box>
          )}

          {features?.map((feature, index) => (
            <Grid
              item
              xs={12}
              sm={12}
              md={4}
              key={index}
              sx={{ px: { md: 6, xs: 1 } }}
              gap={4}
            >
              <CardComponent
                CardActionsReqd={false}
                height={isMobile ? "100%" : 250}
                width={isMobile ? "100%" : 100}
                image={false}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: { xs: "row", md: "column" },
                    gap: 2,
                    justifyContent: { xs: "flex-start", md: "flex-end" },
                    alignItems: { xs: "flex-start", md: "center" },
                  }}
                >
                  <Image src={feature?.src} width={isMobile ? 20 : 30} />
                  <Stack>
                    <Typography
                      sx={{
                        fontSize: "14px",
                        textAlign: { xs: "left", md: "center" },
                      }}
                      fontWeight={"bold"}
                    >
                      {feature?.title}
                    </Typography>
                    <Typography
                      fontWeight={400}
                      lineHeight={"18px"}
                      fontSize={"14px"}
                      sx={{
                        mt: { xs: 0, md: 2 },
                        textAlign: { xs: "justify", md: "center" },
                      }}
                      color="#3F3F3FCC"
                    >
                      {feature?.description}
                    </Typography>
                  </Stack>
                </Box>
              </CardComponent>
            </Grid>
          ))}
        </Grid>
      </Box>
      <ApplicationStepper />
    </>
  );
};

export default FeaturesUI;
